// @ts-nocheck
import { fetchInitiateStatement, fetchJobStatusStatement, fetchStatements, fetchViewStatement } from '../api';
import { call, put } from 'redux-saga/effects';
import {
  statementsFetched,
  statementsFetchFailed,
  statementViewFetched,
  statementViewFetchFailed,
  setStatementLoadPercentage,
  jobStatementFetched,
  jobStatementFetchFailed,
  initiateStatementFetched,
  initiateStatementFetchFailed,
} from '../reducer/statementsSlice';
import { Buffer } from 'buffer';
import { isWeb } from '../storage';
import { store } from '../store';

let RNFS: any;
if (!isWeb) {
  RNFS = require('react-native-fs');
}

export function* fetchStatementsSaga(action) {
  const { accountId, customerId, nextEndDate, isRefresh } = action.payload;
  try {
    const response = yield call(
      fetchStatements,
      'statements',
      accountId,
      customerId,
      nextEndDate,
      isRefresh
    );
    yield put(statementsFetched(response?.estatementResponse));
  } catch (error) {
    console.log('Error', error);
    yield put(statementsFetchFailed(error));
  }
}

export function* fetchInitiateStatementSaga(action) {
  const { accountId, customerId, statementId, statementDate, cycleDate, isRefresh } = action.payload;
  try {
    const response = yield call(
      fetchInitiateStatement,
      'initiateStatement',
      accountId,
      customerId,
      statementId,
      statementDate, 
      cycleDate,
      isRefresh
    );
    yield put(initiateStatementFetched(response));
  } catch (error) {
    console.log('Error', error);
    yield put(initiateStatementFetchFailed(error));
  }
}

export function* fetchJobStatusStatementSaga(action) {
  const { accountId, customerId, jobId, statementId, statementDate, cycleDate, isRefresh } = action.payload;
  try {
    const response = yield call(
      fetchJobStatusStatement,
      'jobStatusStatement',
      accountId,
      customerId,
      jobId,
      statementId,
      statementDate,
      cycleDate,
      isRefresh
    );
    yield put(jobStatementFetched(response?.status));
  } catch (error) {
    console.log('Error', error);
    yield put(jobStatementFetchFailed(error));
  }
}

export function* fetchViewStatementSaga(action) {
  const { accountId, customerId, statementId, recaptchaToken, statementDate, cycleDate } = action.payload;

  const loaderFunction = (percent) => {
    console.log('loading%Sage', percent)
    store.dispatch(setStatementLoadPercentage(percent));
  }

  try {
    const response = yield call(
      fetchViewStatement,
      'viewStatement',
      accountId,
      customerId,
      statementId,
      statementDate,
      cycleDate,
      recaptchaToken,
      loaderFunction
    );
    // -----------------------------------------------------------
    // WEB HANDLING
    // -----------------------------------------------------------
    if (isWeb) {
      try {
        const uint8 = new Uint8Array(response);
        const blob = new Blob([uint8], { type: 'application/pdf' });
        const tempFileUrl = URL.createObjectURL(blob);
        console.log('PDF URL (web):', tempFileUrl);
        yield put(statementViewFetched(tempFileUrl));
      } catch (error) {
        console.error('Error processing viewStatement in Web:', error);
      }
      return;
    }
    // -----------------------------------------------------------
    // MOBILE HANDLING (IOS + ANDROID)
    // -----------------------------------------------------------

    try {
      const uint8 = new Uint8Array(response);

      const base64 = Buffer.from(uint8).toString('base64');

      const path = `${RNFS.DocumentDirectoryPath}/${Date.now()}.pdf`;

      // Always write a fresh file
      yield call(RNFS.writeFile, path, base64, 'base64');
      console.log('PDF saved to:', path);
      yield put(statementViewFetched(path));
    } catch (e) {
      console.log('PDF file operation failed:', e);
      throw e;
    }
  } catch (error) {
    console.log('Error:', error);
    yield put(statementViewFetchFailed(error));
  }
}